<template>
  <div id="app">
    <ExcelSheet  
    fileName="TransferBookingExcel"
    :importData="importData" >
     
      <template v-slot:top>
       
        <div
        style="width:300px ;float:left; ">
        <universal-input 
        label="fromDate"
        v-model="centerFilter"
        :config="centerFilterConfig"
      >
      </universal-input>
    </div>
 
    <div
    style="width:300px ;float: left; padding-left:12px">
      <universal-input
      v-model="courseFromDate"
      :config="courseFromDateConfig"
      @input="handleCourseFromDateInput"
    ></universal-input>
  </div>

  <div
  style="width:300px ;float: left; padding-left:12px">
    <universal-input
    v-model="courseToDate"
    :config="courseToDateConfig"
    @input="handleCourseToDateInput"
  ></universal-input>
</div>
      </template>

    </ExcelSheet>
   
  </div>
</template>

<script setup>
 
import  ExcelSheet   from '@/components/Excel/excelSheet.vue'

import {  showExcel } from '@/api/bookedCourse'

import {ownCenterList} from '@/api/center'
import moment from '@/utils/moment'

import { ref, onMounted, computed, toRefs, watch , onBeforeMount } from 'vue'
import { autoResetRef } from '@vueuse/core'
import UniversalInput from '@/components/CRUD/UniversalInput'

const headerJSON = ref( [])
  const coachCenterList = ref([])
  const TempData = ref([])
  const importData = ref({})
  const merge = ref([])
  const centerFilter = ref(0)
  const centerFilterConfig = ref({
  name: 'centerFilter',
  label: 'Center',
  type: {
    name: 'autocomplete',
    items: coachCenterList.value,
  },
})

 
const courseFromDate = ref('')
const courseToDate = ref('')
const border_1 = ref([])
const startingRowNumber = ref(4)
 



watch(centerFilter,  newValue => {
 
    callAPI({CenterID : newValue, ToDate: courseToDate.value , FromDate : courseFromDate.value})
   
 
}
 
)

const courseFromDateConfig = ref({
  propName: 'courseFromDate',
  label: 'From Date',
  toplabel: 'Select Course Date',
  type: {
    name: 'datepicker',
  },
})

const courseToDateConfig = ref({
  propName: 'courseToDate',
  label: 'To Date',
  toplabel: 'Select Course Date',
  type: {
    name: 'datepicker',
  },
})
 

watch(centerFilter,  newValue => {
  if (newValue){
    callAPI({CenterID : centerFilter.value , ToDate: courseToDate.value , FromDate : courseFromDate.value})
   
  
}
}
 
)

watch(courseFromDate,  newValue => {
  if (newValue){
    callAPI({CenterID : centerFilter.value , ToDate: courseToDate.value , FromDate : newValue})
   
  
}

headerJSON.value =  [
  { Info: 'Course Booking Transfer Summary' , fs: 18 },
  { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' , bg : '#808080'  }, // for header row 5
  // #D9D9D9  other gray
  ]


}
 
)

watch(courseToDate,  newValue => {
  if (newValue){
    callAPI({CenterID : centerFilter.value , ToDate: newValue, FromDate : courseFromDate.value})
    
}

headerJSON.value =  [
  { Info: 'Course Booking Transfer Summary' , fs: 18 },
  { Info: 'Date : ' + courseFromDate.value + ' to ' +  newValue ,fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' , bg : '#808080'  }, // for header row 5
  // #D9D9D9  other gray
  ]

  
} 
 
)


onMounted(() => {
 
  courseFromDate.value =   moment().subtract(7, 'days').format('YYYY-MM-DD')
courseToDate.value =  moment().format('YYYY-MM-DD') 





coachCenterList.value.push({
          id: 0,
          label: 'ALL',
        })

//  initLuckysheet()
ownCenterList().then(response => {
  console.log('response',response)
  // const firstItem = response.data.items[0].id
 
  for (let index = 0; index < response.data.items.length; index += 1) {
      const item = response.data.items[index]
      if (item) {
 
        coachCenterList.value.push({
          id: item.id,
          label: item.code,
        })
   
      }
    }
    console.log('coachCenterList.value',coachCenterList.value)

    
 
//  console.log('TheDate:' , new Date("2023-03-29 17:37:28"))
 showExcel({CenterID : centerFilter.value , ToDate: courseToDate.value , FromDate : courseFromDate.value
//  .moment().format('YYYY-MM-DD') 
})
     .then(lockerExcelresponse => {
      // console.log('lockerExcelresponse',lockerExcelresponse)
      let newArray =  lockerExcelresponse.data.record;
      // console.log('newArray',newArray)
      newArray = addBgToEverySecondRow(newArray)
      // console.log('addBgToPreSecondLockerID',newArray)
      newArray  = convertTransactionDates(newArray)
   
      // merge.value = generateMergeJson(newArray, 6 , 0)
  
      TempData.value =   [...headerJSON.value, ...newArray];
    //  console.log('importData',importData.value)

    const temp =  initLuckysheet(TempData.value)
    console.log('temp',temp)
    importData.value = temp

     


     })
     .catch(err => {  
      console.log('err',err)
      })
     })
     .catch(err => {  
      console.log('err',err)
      })



})

function handleCourseFromDateInput(dateValue) {
 console.log('dateValue',dateValue )
}

function handleCourseToDateInput(dateValue) {
  console.log('dateValue',dateValue )
}


function addBgToPreSecondLockerID(lockers) {
  let addColor = false // if true add color
  let tempID = 0
  try
  {
    tempID = lockers[0].lockerID;
  }catch
  {

  }
 
  for (let i = 0; i < lockers.length; i++) {
    

    if (i == 0)
    {

    }
    else{
       if (lockers[i].lockerID != tempID){
        addColor = !addColor
        tempID = lockers[i].lockerID 
       }


      if (addColor)
       lockers[i].bg = '#D9D9D9';
 
    }

 
  }
 
  return lockers;
}
 

function addBgToEverySecondRow(lockers) {
  for (let i = 0; i < lockers.length; i++) {
    if ((i%2) != 0)
       lockers[i].bg = '#D9D9D9';
  }
    
  return lockers;
}
 
function generateMergeJson(data, rowOffset, columnOffset) {
  const mergeJson = {};
  const mergeStart = {};
  const keysToMerge = ["lockerNo", "lockerSize", "lockerStatus" , "currentUser"];

  data.forEach((row, i) => {
    let lockerIdMatch = true;
    if (i === 0 || row["lockerID"] !== data[i - 1]["lockerID"]) {
      lockerIdMatch = false;
    }

    if (lockerIdMatch) {
      keysToMerge.forEach((key) => {
        mergeStart[key] = (mergeStart[key] || 0) + 1;
      });
    } else {
      keysToMerge.forEach((key, j) => {
        if (mergeStart[key] && mergeStart[key] > 1) {
          const mergeKey = `${i - mergeStart[key] + rowOffset}_${j + columnOffset}`;
          mergeJson[mergeKey] = {
            rs: mergeStart[key],
            cs: 1,
            r: i - mergeStart[key] + rowOffset,
            c: j + columnOffset,
          };
        }
        mergeStart[key] = 1;
      });
    }
  });

  keysToMerge.forEach((key, j) => {
    if (mergeStart[key] && mergeStart[key] > 1) {
      const mergeKey = `${data.length - mergeStart[key] + rowOffset}_${j + columnOffset}`;
      mergeJson[mergeKey] = {
        rs: mergeStart[key],
        cs: 1,
        r: data.length - mergeStart[key] + rowOffset,
        c: j + columnOffset,
      };
    }
  });

  return  mergeJson ;
}



function convertTimestamp(timestamp) {
  const momentObj = moment(timestamp);
  const formattedDate = momentObj.format('DD/MM/YYYY');
  const formattedTime = momentObj.format('hh:mm:ss A');

  return `${formattedDate} ${formattedTime}`;
}

function convertTransactionDates(json) {
  json.forEach(obj => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && moment(obj[key], moment.ISO_8601).isValid()) {
        const momentObj = moment(obj[key]);
        const formattedDate = momentObj.format('DD/MM/YYYY hh:mm:ss A');
        obj[key] = formattedDate;
      }
    }
  });
  return json;
}

function calculateColumnWidths(celldata) {
  const colWidths = {};

  celldata.forEach((cell) => {
    const { c, v } = cell;
    const content = v.v;
    const fontSize =    cell.v.fs ?  cell.v.fs  :  12
    // const width = content.toString().length * 10 * fontSize/10; // 10 is an approximate width per character
    // const width = content.toString().length *  fontSize /1.15;
    let width = content.toString().length * fontSize / 1.6
    if (width){
      if (width <= 73) {
      width = 73
    }
   
    }
 

    if (!colWidths[c] || width > colWidths[c]) {
      colWidths[c] = width;
    }
  });
 
  return colWidths;
 
}

function calculateColumnHeights(celldata) {
  const colHeights = {};

  celldata.forEach((cell) => {
    
    const { c, r } = cell;
    // const content = v.v;
    // const lines = content.toString().split(/\r\n|\r|\n/).length; // Count the number of lines in the content
    const fontSize =    cell.v.fs ?  cell.v.fs  :  12
    const lineHeight = fontSize * 1.2; // Calculate the line height based on the font size, assuming 1.2x the font size as a standard
    const height = lineHeight;

    if (!colHeights[r] || height > colHeights[r]) {
      colHeights[r] = height;
    }
  });

  return colHeights;
}

function  jsonToCelldata(jsonData) {
 

    const headers = ['Booking ID', 'Center', 'Date', 'Session', 'Membership Name',  'Course'   ,'Orginal Coach'   , 'Transfer To' , 'Transfer Date' ];
  console.log('jsonData',jsonData)
  const celldata = [];

  jsonData.forEach((item, row) => {
    if (row < 4) {
      //please check theitem.fs
      // const fs = value === undefined ? 12 : item.fs;
  
      const infoCell = {
        r: row,
        c: 0,
        v: { m: item.Info, ct: { fa: 'General', t: 's' }, v: item.Info , fs: item.fs ? item.fs : 12 },
      };
      celldata.push(infoCell);
    } else {
      if (row === 4) {
        headers.forEach((header, c) => {
          celldata.push({
            r: row,
            c,
            v: { m: header, ct: { fa: 'General', t: 's' }, v: header , bg : item.bg ? item.bg  : '#FFFFFFF'  },
          });
        });
      } else {
   
        const rowData = [
          item.bookingNo,
          item.center,
          item.date ,
          item.session  ,
          item.membershipName  ,
          item.course  ,
          item.originalCoach ,
          item.transferTo ,
          item.transferDate  ,
        ];
      

        rowData.forEach((value, c) => {
          console.log('rowData.forEach((value' , value)
          const stringValue = value === undefined ? '' : value.toString();
           

          const cell = {
            r: row,
            c,
            v: {
              m: stringValue,
              ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
              v: stringValue,
              bg : item.bg ? item.bg : '#FFFFFF'
            },
          };
          celldata.push(cell);
        });
      }
    }
  });
console.log('celldata',celldata)
  return celldata;
}

function addBorderToManyCell(data ,   { minusRow = 1,   minumumR = 4   ,  style = "1",  color = '#000000'  }) {
 
 let smallestR = Infinity;
   let smallestC = Infinity;

   let largestR = -1;
   let largestC = -1;


   for (let item of data) {
       if (item.r > minumumR && item.r < smallestR) {
           smallestR = item.r;
          
       }
       
       if (item.r > largestR) {
           largestR = item.r;
         
       }
       
       if (item.c < smallestC) {
           smallestC = item.c;
     
       }

       if (item.c > largestC) {
           largestC = item.c;
      
       }
   }

  var borderInfo = [];
 
 borderInfo.push({
   "rangeType": "range",
   "borderType": "border-all",
   "style": style,
   "color":color,
   "range": [{
       "row": [smallestR, largestR - minusRow ],
       "column": [smallestC, largestC]
   }]
   });


return borderInfo

}


function initLuckysheet(data) {
 border_1.value = []
  console.log('Sheet loaded')
 
  const celldata = jsonToCelldata(data);
  const colWidths =  calculateColumnWidths(celldata);
  console.log('initLuckysheetcolWidths',colWidths)
  const colHeights=  calculateColumnHeights(celldata);
  console.log('colHeights', colHeights);
  

  border_1.value = [...border_1.value , ...addBorderToManyCell(celldata , { minumumR : startingRowNumber.value - 1 , minusRow: 0 })] 



  var options = {
    container: 'luckysheet',
    title: 'Locker',
    lang: 'zh',
    // showsheetbar: false,
    // defaultColWidth : 'auto',
    data: [
      {
        name: 'Sheet1',
        status: 1,
        celldata: celldata,
        config: {
         
    	authority:{// 当前工作表的权限配置
        sheet: 1, // sheet表下标。
        hintText: "You can not edit any cell", // 弹窗提示的文字
      },
        
            merge: merge.value, //merged cells
            rowlen:{}, //Table row height
       
            columnlen: colWidths,
             rowlen :colHeights, //Table row height
            // columnlen: {
            //       //自定义宽度
            //       0: "auto",
            //       1: 300,
            //       2: 300,
            //       3: 300,
            //       4: 300,
            //     },
            rowhidden:{}, //hidden rows
            colhidden:{}, //hidden columns
            borderInfo:border_1.value , //borders
        },
      }, 
      // {
      //   name: 'Sheet2',
      //   status: 1,
      //   celldata: celldata,
      //   config: {
         
    	// // authority:{// 当前工作表的权限配置
      // //   sheet: 1, // sheet表下标。
      // //   hintText: "You can not edit any cell", // 弹窗提示的文字
      // // },
        
      //       merge:{}, //merged cells
      //       rowlen:{}, //Table row height
      //       columnlen: colWidths,
      //       // columnlen: {
      //       //       //自定义宽度
      //       //       0: "auto",
      //       //       1: 300,
      //       //       2: 300,
      //       //       3: 300,
      //       //       4: 300,
      //       //     },
      //       rowhidden:{}, //hidden rows
      //       colhidden:{}, //hidden columns
      //       borderInfo:{}, //borders
      //   },
      // },
    ],
  };
 
 return options
  } 
 
  function callAPI(data){
    showExcel(data)
     .then(lockerExcelresponse => {
      // console.log('lockerExcelresponse',lockerExcelresponse)
      let newArray =  lockerExcelresponse.data.record;
      // console.log('newArray',newArray)
      newArray = addBgToEverySecondRow(newArray)
      // console.log('addBgToPreSecondLockerID',newArray)
      newArray  = convertTransactionDates(newArray)
   
      // merge.value = generateMergeJson(newArray, 6 , 0)
  
      TempData.value =   [...headerJSON.value, ...newArray];
    //  console.log('importData',importData.value)

    const temp =  initLuckysheet(TempData.value)
    console.log('temp',temp)
    importData.value = temp

      
    // initLuckysheet(newValue)
     })
     
     .catch(err => {  
      console.log('err',err)
      })
  }
 


 
</script>